import React, { FC, useState } from "react";
import { BrandedFareClientFeature } from "@flights/types";
import { Button, Icon, Popover, SheetContainer } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import FareFeature from "./index";
import useUserAgent from "../../../hooks/useUserAgent";
import { t, useI18n } from "@bookingcom/lingojs-react";
import flights_apex_web_bf_cta_visibility_v2 from "../../../utils/experiments/apex/flights_apex_web_bf_cta_visibility_v2";

const PopoverFareFeatures: FC<{
  features: BrandedFareClientFeature[];
}> = ({ features }) => {
  const [showModal, setShowModal] = useState(false);
  const { isMobile } = useUserAgent();
  const i18n = useI18n();

  return isMobile ? (
    <>
      <Button
        variant="tertiary-neutral"
        onClick={(event) => {
          event.stopPropagation();
          flights_apex_web_bf_cta_visibility_v2.goals.tap_info_button();
          setShowModal(true);
        }}
        attributes={{ "data-testid": "popover-trigger-mobile" }}
      >
        <Icon svg={InfoSignIcon} size="medium" color="neutral_alt" />
      </Button>
      <SheetContainer
        active={showModal}
        hideClose
        position="bottom"
        onCloseTrigger={() => setShowModal(false)}
        attributes={{
          "data-testid": "popover-content-mobile",
          "aria-label": i18n.trans(t("a11y_flights_branded_fares_prio_services_tooltip_open"))
        }}
      >
        {i18n.trans(
          t("flights_branded_fares_prio_services_botttom_sheet_mdot", {
            variables: {
              prio_services_included: features
                .map((feature, index) => (index > 0 ? feature.label.toLocaleLowerCase() : feature.label))
                .join(", ")
            }
          })
        )}
      </SheetContainer>
    </>
  ) : (
    <Popover triggerType="hover" hideClose onOpen={() => flights_apex_web_bf_cta_visibility_v2.goals.hover_info_icon()}>
      <Popover.Trigger>
        {(attributes) => (
          <Icon
            svg={InfoSignIcon}
            size="medium"
            color="neutral_alt"
            attributes={{
              ...attributes,
              "data-testid": "popover-trigger-desktop",
              "aria-label": i18n.trans(t("a11y_flights_branded_fares_prio_services_tooltip_open"))
            }}
          />
        )}
      </Popover.Trigger>
      <Popover.Content>
        {features.map((feature) => (
          <FareFeature
            key={feature.featureName}
            content={feature.label}
            availability={feature.availability}
            IconSVG={feature.icon}
          />
        ))}
      </Popover.Content>
    </Popover>
  );
};

export default PopoverFareFeatures;
